import type { ReactNode } from 'react';
import { CardSkeleton } from '@/components/CardSkeleton';

interface CardsGridContainerProps {
  children: ReactNode;
  loading?: boolean;
  skeletonCount?: number;
}

export function CardsGridContainer({
  children,
  loading = false,
  skeletonCount = 4,
}: CardsGridContainerProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {Array.from({ length: skeletonCount }).map((_, index) => (
          <CardSkeleton key={index} />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {children}
    </div>
  );
}
